import { ENVIORNMENTS } from "utils/constants";
import styles from "./styles.module.scss";
import { useRecoilState } from "recoil";
import { golfDtlOrFaceon } from "store/atom";

export const Tabs = ({ activeTab, setActiveTab, tabsArr, variant }) => {
  const [golfDtlOrFaceonState, setGolfDtlOrFaceonState] =
    useRecoilState(golfDtlOrFaceon);

  function handleClickTab(tab) {
    if (variant === "faceonOrDTL") {
      return setGolfDtlOrFaceonState(tab.key);
    }
    setActiveTab(tab.key);
  }

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabsArr.map((tab) => (
          <div
            className={`
  ${styles[tab.key === (variant === "faceonOrDTL" ? golfDtlOrFaceonState : activeTab) ? "activeSingleTab" : "singleTab"]}
  
`}
            key={tab.key}
            onClick={() => handleClickTab(tab)}
          >
            {tab.title}
          </div>
        ))}
      </div>
    </div>
  );
};
